var render = function render(){var _vm=this,_c=_vm._self._c;return (_vm.showTips)?_c('div',{staticClass:"tips-wrapper"},[_c('Alert',{attrs:{"type":"error","show-icon":"","closable":""},on:{"on-close":_vm.close}},[_vm._v(" 温馨提示 "),_c('span',{attrs:{"slot":"desc"},slot:"desc"},[_vm._v(" 当前分辨率影像您的体验，建议您在电脑端浏览或调整分辨率 ")])])],1):_vm._e()
}
var staticRenderFns = []

export { render, staticRenderFns }